"use client";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../feature/store/store";
import {
    displayUserById,
    setUserId,
    setUserInfo,
    userLogoutApi,
} from "../../../feature/reducers/userSlice";
import { NotificationService } from "../../../service/NotificationService";

export const FALLBACK_AVATAR = "/userImage.png";

// Fehlt ein Profilbild auf dem Server, stattdessen das Ersatzbild zeigen
export const onAvatarError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    if (!e.currentTarget.src.endsWith(FALLBACK_AVATAR)) {
        e.currentTarget.src = FALLBACK_AVATAR;
    }
};

// Einmal in der Navbar: eingeloggten User aus dem localStorage übernehmen
export const useAuthInit = () => {
    const dispatch = useDispatch<AppDispatch>();
    const userId = useSelector((state: RootState) => state.users.userId);
    const user = useSelector((state: RootState) => displayUserById(state, userId));

    useEffect(() => {
        const storedId = localStorage.getItem("userId") || "";
        if (storedId) {
            dispatch(setUserId(storedId));
            dispatch(setUserInfo(user));
        } else {
            dispatch(setUserId(""));
            dispatch(setUserInfo(null));
        }
    }, [dispatch]);
};

// Aktueller User + Abmelden – für Desktop- und Handy-Navigation
export const useAuthUser = () => {
    const dispatch = useDispatch<AppDispatch>();
    const router = useRouter();
    const userId = useSelector((state: RootState) => state.users.userId);
    const user = useSelector((state: RootState) => displayUserById(state, userId));

    const logout = async () => {
        try {
            const response = await dispatch(userLogoutApi()).unwrap();
            dispatch(setUserId(""));
            dispatch(setUserInfo(null));
            NotificationService.success(response.message);
            router.push("/login");
        } catch (error: any) {
            NotificationService.error(
                "Logout fehlgeschlagen: " + ((error as Error)?.message || "Unbekannter Fehler")
            );
        }
    };

    return { user, logout };
};